import intlTelInput from 'intl-tel-input';
import telUtils from 'intl-tel-input/build/js/utils';

export function phoneNumberFormatter({ inputId, phoneAttributeName }) {
  const input = document.querySelector(inputId);

  // Plugin initialization
  const iti = intlTelInput(input, {
    autoHideDialCode: false,
    formatOnDisplay: true,
    hiddenInput: phoneAttributeName,
    initialCountry: 'FR',
    nationalMode: false,
    preferredCountries: ['fr', 'ch'],
    separateDialCode: true,
    utilsScript: telUtils,
  });

  // On focus loss -> validate
  input.addEventListener('blur', () => {
    if (!input.value.trim()) return;

    input.classList.toggle('is-invalid', !iti.isValidNumber());
  });
}
